import React from 'react';
import PropTypes, { string } from 'prop-types';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var FAQLayout = function FAQLayout(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('faq', className),
    "data-t-id": "layouts-FAQLayout"
  }, children);
};
FAQLayout.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  className: string
} : {};